/**
 * Ícones SVG inline (sem Font Awesome) usados nas ações do Hub público da
 * receita. Apresentacionais e reutilizáveis entre /prescricao e /assinatura.
 * Herdam a cor via `currentColor`.
 */

export const IconeBaixar = () => (
  <svg width='22' height='22' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M12 3v12m0 0l-4-4m4 4l4-4'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const IconeValidar = () => (
  <svg width='22' height='22' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M12 2l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V5l7-3z'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinejoin='round'
    />
    <path
      d='M9 12l2 2 4-4'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const IconeDocumento = () => (
  <svg width='22' height='22' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinejoin='round'
    />
    <path d='M14 3v5h5' stroke='currentColor' strokeWidth='1.7' strokeLinejoin='round' />
    <path d='M9 13h6M9 16.5h6' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' />
  </svg>
)

export const IconeDispensar = () => (
  <svg width='22' height='22' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <rect
      x='3'
      y='8'
      width='18'
      height='9'
      rx='4.5'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinejoin='round'
    />
    <path d='M12 8v9M3 12.5h18' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' />
  </svg>
)
